import { useStyles } from "./style";
import { Dropdown } from "../Dropdown";
import { Box, Icon } from "@material-ui/core";
import { useSelector } from "react-redux";
import { Translator } from "@itarget/shared";
export default function ContactButtons({ items = [] }) {
  const systemTheme = useSelector((state) => state.theme.systemTheme);
  const classes = useStyles({ theme: systemTheme });
  if (items.length == 0) return <></>;
  return (
    <>
      <Box className={classes.container}>
        {items.map((item, index) => (
          <a
            key={index}
            href={item.url}
            className={classes.itemLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box
              component="span"
              className={classes.icon}
              dangerouslySetInnerHTML={{ __html: item.icon }}
            />
            <Translator transRef={`translation.${item.description}`} />
          </a>
        ))}
      </Box>

      <Dropdown className={classes.containerMobile} position="top-left">
        <Dropdown.Button className={classes.dropdownButton}>
          <>
            <Icon>contact_support</Icon>
            <Translator transRef="translation.Ajuda" />
          </>
        </Dropdown.Button>

        <Dropdown.Menu items={items} />
      </Dropdown>
    </>
  );
}
